<template>
  <div>
    <div v-if="profile && profile.avatar" :style="styles" class="social-step-editor-main-avatar__profile">
      <img
        :src="profile.avatar"
        :alt="profile.name ? profile.name : 'Profile Avatar'"
        class="social-step-editor-main-avatar__img"
      />
    </div>
    <div v-else :style="styles" class="social-step-editor-main-avatar__empty">
      <img
        :src="`/wp-content/themes/snappy-theme/assets/images/builders/social_profile.svg`"
        alt="Profile Avatar"
        class="social-step-editor-main-avatar__img"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 40,
    },
    profile: Object,
  },
  computed: {
    styles() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.social-step-editor-main-avatar {
  &__profile,
  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 50%;
    overflow: hidden;
  }

  &__empty {
    border: 2px solid rgba(0, 0, 0, 0.1);
  }

  &__img {
    height: inherit;
  }
  &__empty &__img {
    height: 60%;
  }
}
</style>
